import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="flex-shrink-0 py-4 md:py-8" role="contentinfo">
      <div className="flex items-center justify-center">
        <img
          src={`${process.env.PUBLIC_URL}/assets/logo-competensys.svg`}
          alt="Competensys"
          className="h-9"
        />
      </div>
    </footer>
  );
};

export default Footer; 